import { RegistrarseComponent } from './../registrarse/registrarse.component';


import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';
import { OlvidoComponent } from '../olvido/olvido.component';
import { AuthService } from '../service/seguridad/auth.service';
import { Usuario } from '../service/usuario.model';
import { MensajeComponent } from '../mensaje/mensaje.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuariosDataService } from '../service/data/usuarios-data.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false
})
export class LoginComponent implements OnInit {


 
  usuario:Usuario
  errorMessage="Invalid credentials";
  invalidLogin =false;
  cargando: boolean = false;

  constructor( 
    //public autenticacion: HardcodedAutheticationService,
    public dialog: MatDialog,
    private location: Location,
    private auth:AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private usuariosService: UsuariosDataService) { 

  }

  ngOnInit(): void {
   this.usuario = new Usuario();
   
   this.route.queryParams.subscribe(params => {
    if (params['regToken']) {
      this.handleGoogleRegister(params['regToken']);
    } else if (params['logToken']) {
      this.handleGoogleLogin(params['logToken']);
    } else if (params['error']) {
      this.openMensaje('Error en el login con Google. Intente nuevamente.');
    }
  });


  }


  
  handleLogin(){
  
    
    if(this.usuario.correo==null || this.usuario.contrasena==null){
      //alert('Username o Password vacios');
      this.openMensaje('Username o Password vacios');
      return;
    }

    this.auth.logout();

    this.usuario.correo=this.usuario.correo.trim();
    
    this.auth.login(this.usuario).subscribe({next:response => {

       this.auth.guardarUsuario(response.access_token);
       this.auth.guardarToken(response.access_token);
      
       let usuario = this.auth.usuario;

      
      
  },
  error:error => {
    if(error.status == 400){
      //alert('Usuario o clave incorrectos');
      this.openMensaje('Usuario o clave incorrectos');
    }
    this.usuario = new Usuario();
    this.invalidLogin =true;
  }}
  );


  }
  olvidoContrasenia(){
    const dialogRef = this.dialog.open(OlvidoComponent, {
      width: '600px'      
    });

    dialogRef.afterClosed().subscribe(result => {
      
      
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(RegistrarseComponent, {
      width: '600px',
      height:'750px'
      
    });

    dialogRef.afterClosed().subscribe(result => {
      
      
    });
  }

  openMensaje(mensajeT:string,openD?:string):void{
    let screenWidth = screen.width;
    let anchoDialog:string = '500px';
    let anchomax:string = '80vw';
    let altoDialog:string = '250';
    if(screenWidth<=600){
      anchoDialog = '100%';
      anchomax = '100%';
      altoDialog = 'auto';
    }
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: anchoDialog,
      maxWidth: anchomax,
      height: altoDialog,
      data:{
        mensaje:mensajeT
      }
    });
  }

  loginWithGoogle(): void {
    this.cargando = true;
    this.auth.loginWithGoogle();
  }

// === FLUJO GOOGLE ===

  private handleGoogleRegister(regToken: string): void {
    this.auth.validateRegistrationGoogleToken(regToken).subscribe({
      next: googleData => this.abrirRegistroConGoogle(googleData),
      error: () => {
        this.openMensaje('Error procesando registro con Google');
        this.router.navigate(['/home'], { replaceUrl: true });
      }
    });
  }

  private handleGoogleLogin(regToken: string): void {
    this.cargando = true;
    
    this.auth.validateLoginGoogleToken(regToken).subscribe({
      next: response => {

        if (response.action === 'ASSOCIATE_GOOGLE') {
          // No desactivar cargando aquí porque handleGoogleAssociation lo maneja
          this.handleGoogleAssociation(response);
          return;
        }
        
        this.auth.googleLogin(response.idToken).subscribe({
          next: loginResponse => {
            this.cargando = false;
            this.auth.guardarUsuario(loginResponse.access_token);
            this.auth.guardarToken(loginResponse.access_token);
            
            // Mostrar mensaje de bienvenida y recargar cuando cierren el diálogo
            const nombreUsuario = this.auth.usuario.nombre || this.auth.usuario.usuario;
            const dialogRef = this.dialog.open(MensajeComponent, {
              width: '500px',
              maxWidth: '80vw',
              height: 'auto',
              data: {
                mensaje: `Bienvenido de vuelta ${nombreUsuario}`
              }
            });
            
            dialogRef.afterClosed().subscribe(() => {
              const redirectUrl = this.auth.getRedirectUrl();
              window.location.href = redirectUrl;
            });
          },
          error: () => {
            this.cargando = false;
            this.openMensaje('Error en el login con Google.');
            this.router.navigate(['/home'], { replaceUrl: true });
          }
        });
      },
      error: () => {
        this.cargando = false;
        this.openMensaje('Error validando token con Google.');
        this.router.navigate(['/login'], { replaceUrl: true });
      }
    });
  }

  private abrirRegistroConGoogle(googleData: any): void {
    this.dialog.closeAll();
    setTimeout(() => {
      const dialogRef = this.dialog.open(RegistrarseComponent, {
        width: '600px',
        height: '750px',
        data: { googleData }
      });
      dialogRef.afterClosed().subscribe(() => {
        // Mostrar spinner durante login automático después de registro
        this.cargando = true;
        
        // Después de cerrar el registro, hacer login automático con el idToken de Google
        this.auth.googleLogin(googleData.idToken).subscribe({
          next: loginResponse => {
            this.cargando = false;
            this.auth.guardarUsuario(loginResponse.access_token);
            this.auth.guardarToken(loginResponse.access_token);
            
            const nombreUsuario = this.auth.usuario.nombre || this.auth.usuario.usuario;
            const dialogRef = this.dialog.open(MensajeComponent, {
              width: '500px',
              maxWidth: '80vw',
              height: 'auto',
              data: {
                mensaje: `¡Bienvenido ${nombreUsuario}! Tu cuenta ha sido creada exitosamente.`
              }
            });
            
            dialogRef.afterClosed().subscribe(() => {
              const redirectUrl = this.auth.getRedirectUrl();
              window.location.href = redirectUrl;
            });
          },
          error: () => {
            this.cargando = false;
            this.openMensaje('Error en el login automático. Por favor inicia sesión manualmente.');
            this.router.navigate(['/login'], { replaceUrl: true });
          }
        });
      });
    }, 100);
  }

  private handleGoogleAssociation(response: any): void {
    
    // El spinner ya está activo desde handleGoogleLogin, no necesita reactivarse
    
    // Extraer información necesaria
    const correo = response.correo;
    const accessToken = response.accessToken
    const googleId = response.googleId
    const idToken = response.idToken

    this.usuariosService.asociarGoogle(correo, googleId, accessToken).subscribe({
      next: () => {
        // Auto-login después de la asociación exitosa
        this.auth.googleLogin(idToken).subscribe({
          next: loginResponse => {
            this.cargando = false;
            this.auth.guardarUsuario(loginResponse.access_token);
            this.auth.guardarToken(loginResponse.access_token);
            
            // Mostrar mensaje y recargar cuando cierren el diálogo
            const dialogRef = this.dialog.open(MensajeComponent, {
              width: '500px',
              maxWidth: '80vw',
              height: 'auto',
              data: {
                mensaje: 'Tu cuenta de Google fue asociada correctamente con tu cuenta All Tickets!'
              }
            });
            
            dialogRef.afterClosed().subscribe(() => {
              const redirectUrl = this.auth.getRedirectUrl();
              window.location.href = redirectUrl;
            });
          },
          error: () => {
            this.cargando = false;
            this.openMensaje('Asociación exitosa. Por favor inicia sesión nuevamente.');
            this.router.navigate(['/login'], { replaceUrl: true });
          }
        });
      },
      error: error => {
        this.cargando = false;
        console.error('Error en asociación:', error);
        this.openMensaje('Error al asociar cuenta de Google. Intente nuevamente.');
        this.router.navigate(['/login'], { replaceUrl: true });
      }
    });
  }
  
}
